export const CEP_SIZE = 8;
export const CEP_MASK = '00000-000';

export function validarCEP(cep: string): boolean {
  const cepLimpo = cep.replace(/\D/g, '');

  if (cepLimpo.length !== 8) {
    return false;
  }

  const regexCEP = /^\d{5}-?\d{3}$/;
  return regexCEP.test(cep);
}
